import styled, { css } from "styled-components";

const variants = {
  primary: css`
    color: var(--navigation);
  `,
  secondary: css`
    color: var(--icon-color-secondary);

    &:hover {
      background-color: none;
      border-radius: 1.5rem;
    }
  `,
};

const StyledIconButton = styled.button`
  background: none;
  padding: 0.6rem;
  border: none;
  align-items: flex-start;
  transition: all 0.2s;
  border-radius: 1.5rem;

  & svg {
    height: 1.5rem;
    width: 1.5rem;
    ${(props) => variants[props.variant]}
  }

  &:hover {
    background-color: var(--icon-color-hover);
  }
`;

function IconButton({ children, onClick, variant = "primary" }) {
  return (
    <StyledIconButton onClick={onClick} variant={variant}>
      {children}
    </StyledIconButton>
  );
}

export default IconButton;
